import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Col,
  Row,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

const AddPropertyModal = ({ isOpen, toggle, condominiumName, onAdd }) => {
  const [more, setMore] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const handleConfirm = () => {
    onAdd(quantity);
    toggle();
    // Reset local state
    setMore(false);
    setQuantity(1);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} data-testid="modal">
      <ModalHeader toggle={toggle}>Añadir propietario</ModalHeader>
      <ModalBody>
        <Col>
          <Row>
            <Col tag={FormGroup}>
              <p className="font-weight-bold fs--1">
                ¿Está seguro de añadir un nuevo propietario al condominio{" "}
                {condominiumName}?
              </p>
            </Col>
          </Row>
          <Row>
            <Col tag={FormGroup}>
              <Input
                className="position-relative mr-2 ml-2"
                type="checkbox"
                name="more"
                checked={more}
                onChange={(event) => {
                  if (event.target.checked) {
                    setMore(true);
                    setQuantity(1);
                  } else {
                    setMore(false);
                  }
                }}
              />
              <Label for="more">¿Deseas añadir más de uno?</Label>
            </Col>
          </Row>
          {more && (
            <Row>
              <Col tag={FormGroup}>
                <Label>Cantidad de propiedades a registrar</Label>
                <Input
                  size="sm"
                  type="number"
                  name="quantity"
                  min={1}
                  value={quantity}
                  onChange={(event) => setQuantity(event.target.value)}
                />
              </Col>
            </Row>
          )}
          {/* HO-ISSUE-120: acá se crean unidades en blanco y nada avisaba que
          después hay que ponerle el inmueble a cada una. Sin ese dato el
          propietario no se distingue del resto cuando se le asignan gastos,
          y el administrador se enteraba recién ahí. */}
          <Row>
            <Col>
              <Alert color="info" className="fs--1 mb-0">
                {quantity > 1 && more
                  ? "Las unidades se crean en blanco. "
                  : "La unidad se crea en blanco. "}
                Acuérdate de asignarle el <strong>inmueble</strong> a cada una
                desde <strong>Editar</strong>: es el nombre o número que la
                identifica dentro del condominio y con el que la reconoces al
                asignarle gastos.
              </Alert>
            </Col>
          </Row>
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button onClick={toggle}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleConfirm}>
          Agregar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddPropertyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  condominiumName: PropTypes.string,
  onAdd: PropTypes.func.isRequired,
};

export default AddPropertyModal;
